import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import userReducer from './slices/userSlice';
import registerReducer from './registerSlice';
import facilityReducer from './facilitySlice'; // Import the facility reducer
import viewSlotReducer from './slotSlice';
import bookingReducer from './bookingSlice'; // Import the booking reducer
import viewPitchReducer from './viewPitchSlice'; // Import the viewPitch reducer
import addFacilityReducer from './slices/AddFacilitySlice'; // Import the AddFacility reducer
import getSportsReducer from './slices/getSportsSlice';
import pitchReducer from './slices/pitchSlice';
import pitchFiltersReducer from './slices/pitchFiltersSlice';
import slotReducer from './slices/slotSlice';
import facilityReportReducer from './facilityReportSlice';
import scheduleReducer from './scheduleSlice'
import venueFacilitiesReducer from './slices/venueFacilitiesSlice';
import conversationReducer from './slices/conversationSlice';
import messageReducer from './slices/messageSlice';
import recentBookingsReducer from './recentBookingsSlice';
import facilityDailyReportReducer from './facilityDailyReportSlice';
import comprehensiveReportReducer from './comprehensiveReportSlice';
import bookingDetailsReducer from './bookingDetailsSlice';
import socketMiddleware from './middleware/socketMiddleware';
import notificationsReducer from './notificationsSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    register: registerReducer,
    facilities: facilityReducer, 
    slots: slotReducer,
    bookings: bookingReducer,
    pitches: viewPitchReducer, 
    addFacility: addFacilityReducer, 
    sports: getSportsReducer,
    pitch: pitchReducer,
    pitchFilters: pitchFiltersReducer,
    facilityReport: facilityReportReducer,
    schedule: scheduleReducer,
    venueFacilities: venueFacilitiesReducer,
    conversations: conversationReducer,
    messages: messageReducer,
    recentBookings: recentBookingsReducer,
    facilityDailyReport: facilityDailyReportReducer,
    comprehensiveReport: comprehensiveReportReducer,
    bookingDetails: bookingDetailsReducer,
    notifications: notificationsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(socketMiddleware()),
});

export default store;
